import React from 'react';
import { RefreshCw } from 'lucide-react';

export function ScheduledTab() {
  return (
    <div className="bg-gray-800 rounded-xl p-6 border border-gray-700">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h3 className="text-xl font-bold text-white">Scheduled Newsletters</h3>
          <p className="text-gray-400 text-sm">Auto-sends within 60 seconds of the scheduled time.</p>
        </div>
        <button
          className="flex items-center gap-2 px-4 py-2 bg-gray-700 hover:bg-gray-600 text-gray-200 rounded-lg transition-colors"
          data-testid="scheduled-refresh-btn"
        >
          <RefreshCw size={16} />
          Refresh
        </button>
      </div>
      <div className="bg-gray-900/50 rounded-lg p-8 text-center">
        <p className="text-gray-400">No scheduled newsletters yet. Use the Compose tab to schedule one.</p>
      </div>
    </div>
  );
}
